import type { PolygonWithHoles, Triangulation } from '../../geo/types';
import { triangulate } from '../../geo/triangulate';
import { refineHeightTriangles, refineTriangles, type DensifyConfig } from '../terrain/densify';
import { withBoundaryStations } from './boundaryTriangulation';

export function groundTriangulation(
  polygon: PolygonWithHoles,
  config: DensifyConfig | undefined
): Triangulation {
  const build = () => {
    const initial = triangulate(polygon);
    if (!config?.surface) return refineTriangles(initial, config);
    const refined = refineTriangles(withBoundaryStations(initial, polygon), config),
      restored = withBoundaryStations(refined, polygon);
    // Original outline stations own the shared edge, including tiny strips left by clipping.
    // Recheck their height planes without mending those stations away again.
    return refineHeightTriangles(restored, config);
  };
  return config?.triangulations?.resolve(polygon, config.surface !== undefined, build) ?? build();
}
